module.exports = __webpack_public_path__ + "img/bb06.d1751499.jpg";